<template>
  <div>
    <v-form ref="form">
      <v-dialog
        fullscreen
        value="true"
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-app-bar flag class="card-toolbar-title">
            <v-toolbar-title>
              {{ editedItem.id ? 'Edit' : 'Add' }} Client
            </v-toolbar-title>
            <v-spacer />
            <v-btn icon @click.native="close">
              <v-icon>close</v-icon>
            </v-btn>
          </v-app-bar>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 md4>
                  <v-text-field
                    id="clientName"
                    v-model="editedItem.clientName"
                    :rules="required"
                    :disabled="!!editedItem.id"
                    label="Client Name"
                    name="clientName"
                    class="required"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    id="clientNameDesc"
                    v-model="editedItem.clientNameDesc"
                    label="Client Description"
                    name="clientNameDesc"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    id="clientDatabaseId"
                    v-model="editedItem.clientDatabaseId"
                    :rules="required"
                    :items="clientDatabaseList"
                    name="clientDatabaseId"
                    label="Database"
                    item-value="databaseId"
                    class="required"
                  >
                    <template v-slot:selection="data">
                      <div style="word-wrap: break-word; max-width: 98%">
                        {{ data.item.userName }}@{{ data.item.connectionUrl }}
                      </div>
                    </template>
                    <template v-slot:item="data">
                      {{ data.item.userName }}@{{ data.item.connectionUrl }}
                    </template>
                  </v-select>
                </v-flex>
                <v-flex xs12>
                  <h3>Client Properties</h3>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    id="trackingGroupTypeCd"
                    v-model="editedItem.trackingGroupTypeCd"
                    label="Tracking Group Type Code"
                    name="trackingGroupTypeCd"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-combobox
                    id="trackingGroupFilter"
                    v-model="editedItem.trackingGroupFilter"
                    label="Tracking Group Filter"
                    name="trackingGroupFilter"
                    :return-object="false"
                    multiple
                    chips
                    deletable-chips
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-combobox
                    id="clientIdFilter"
                    v-model="editedItem.clientIdFilter"
                    label="Client ID Filter"
                    name="clientIdFilter"
                    :return-object="false"
                    multiple
                    chips
                    deletable-chips
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    id="frxClientName"
                    v-model="editedItem.frxClientName"
                    label="FirstRx Client Name"
                    name="frxClientName"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-combobox
                    id="defaultSubmissionAllowAliasType"
                    v-model="editedItem.defaultSubmissionAllowAliasType"
                    :items="defaultSubmissionAllowAliasTypes"
                    item-value="value"
                    item-text="display"
                    label="Default Submission Allow Alias Types"
                    name="defaultSubmissionAllowAliasType"
                    chips
                    :return-object="false"
                    multiple
                    deletable-chips
                  >
                    <template v-slot:item="data">
                      {{ data.item.value }} <span class="subheader">{{ data.item.display }}</span>
                    </template>
                  </v-combobox>
                </v-flex>
                <v-flex xs12 md4>
                  <v-combobox
                    id="submissionAllowAliasType"
                    v-model="editedItem.submissionAllowAliasType"
                    :items="lookups.memberCardholderIdAliasTypes"
                    item-value="value"
                    item-text="display"
                    label="Submission Allow Alias Types"
                    name="submissionAllowAliasType"
                    :return-object="false"
                    multiple
                    chips
                    deletable-chips
                  >
                    <template v-slot:item="data">
                      {{ data.item.value }} <span class="subheader">{{ data.item.display }}</span>
                    </template>
                  </v-combobox>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    id="disabledDefaultAliasType"
                    v-model="editedItem.disabledDefaultAliasType"
                    :items="disabledDefaultAliasTypes"
                    item-value="value"
                    item-text="display"
                    label="Disabled Default Alias Types"
                    name="disabledDefaultAliasType"
                    chips
                    :return-object="false"
                    multiple
                    deletable-chips
                  >
                    <template v-slot:item="data">
                      {{ data.item.value }} <span class="subheader">{{ data.item.display }}</span>
                    </template>
                  </v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-combobox
                    id="maskedAliasType"
                    v-model="editedItem.maskedAliasType"
                    :items="lookups.memberCardholderIdAliasTypes"
                    item-value="value"
                    item-text="display"
                    label="Masked Alias Types"
                    name="maskedAliasType"
                    :return-object="false"
                    multiple
                    chips
                    deletable-chips
                  >
                    <template v-slot:item="data">
                      {{ data.item.value }} <span class="subheader">{{ data.item.display }}</span>
                    </template>
                  </v-combobox>
                </v-flex>
                <v-flex xs12 md4>
                  <v-combobox
                    id="drugCoverageOptions"
                    v-model="editedItem.drugCoverageOptions"
                    :items="lookups.coverageLevels"
                    item-value="value"
                    item-text="display"
                    label="Drug Coverage Options"
                    name="drugCoverageOptions"
                    :return-object="false"
                    multiple
                    chips
                    deletable-chips
                  >
                    <template v-slot:item="data">
                      {{ data.item.value }} <span class="subheader">{{ data.item.display }}</span>
                    </template>
                  </v-combobox>
                </v-flex>
                <v-flex xs12 md4>
                  <v-checkbox
                    id="disableUpdateCDHP"
                    v-model="editedItem.disableUpdateCDHP"
                    label="Disable CDHP Update"
                    name="disableUpdateCDHP"
                    color="primary"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-checkbox
                    id="disableRaceCd"
                    v-model="editedItem.disableRaceCd"
                    label="Disable Race Code"
                    name="disableRaceCd"
                    color="primary"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-checkbox
                    id="disablePersonCd"
                    v-model="editedItem.disablePersonCd"
                    label="Disable Person Code"
                    name="disablePersonCd"
                    color="primary"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <div class="mx-auto">
              <v-btn color="primary" text @click.native="close">Cancel</v-btn>
              <v-btn color="primary" @click.native="save">Save</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import intersectionBy from 'lodash/intersectionBy'

export default {
  name: 'client-table-modal',
  props: {
    editedItem: Object
  },
  data() {
    return {
      disabledDefaultAliasTypes: [
        { value: 'MN', display: 'Member Number' }
      ],
      required: [
        v => !!v || 'Required'
      ]
    }
  },
  computed: {
    ...mapState('manageClient', ['clientDatabaseList', 'clientDatabaseDetails']),
    lookups() {
      return (this.clientDatabaseDetails[this.editedItem.clientDatabaseId] && this.clientDatabaseDetails[this.editedItem.clientDatabaseId].lookups) || {}
    },
    defaultSubmissionAllowAliasTypes() {
      return intersectionBy(this.lookups.memberCardholderIdAliasTypes, [
        { value: 'MN' },
        { value: 'CH' },
        { value: 'MI' },
        { value: 'SI' },
        { value: 'SS' }
      ], 'value')
    }
  },
  methods: {
    ...mapActions('manageClient', ['updateClientDetails', 'addClientDetails']),
    save() {
      if (this.$refs.form.validate()) {
        this[this.editedItem.id ? 'updateClientDetails' : 'addClientDetails'](this.editedItem).then(this.close, () => {})
      }
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
  .card-title {
    background-color: $black-3;
    color: $color-primary;
  }

  .card-toolbar-title {
    background-color: $color-secondary;
  }
</style>
